import React from 'react';
import { Course, Semester } from '../../types/grades';
import { SemesterList } from './SemesterList';
import { SemesterContent } from './SemesterContent';
import { GPASidebar } from './GPASidebar';

interface SemesterGridProps {
  semesters: Semester[];
  setSemesters: (semesters: Semester[]) => void;
  selectedSemesterId: string;
  selectedSemester: Semester;
  onSelectSemester: (id: string) => void;
  onAddSemester: () => void;
  onRemoveSemester: (id: string) => void;
  cumulativeGPA: number;
  handleCourseChange: (index: number, course: Course) => void;
  addCourse: () => void;
  deleteCourse: (index: number) => void;
}

export function SemesterGrid({
  semesters,
  setSemesters,
  selectedSemesterId,
  selectedSemester,
  onSelectSemester,
  onAddSemester,
  onRemoveSemester,
  cumulativeGPA,
  handleCourseChange,
  addCourse,
  deleteCourse
}: SemesterGridProps) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-[250px,1fr] xl:grid-cols-[250px,1fr,300px] gap-6">
      <div className="lg:sticky lg:top-24 h-fit">
        <SemesterList
          semesters={semesters}
          selectedSemesterId={selectedSemesterId}
          onSelectSemester={onSelectSemester}
          onAddSemester={onAddSemester}
          onRemoveSemester={onRemoveSemester}
        />
      </div>

      <div>
        <SemesterContent
          semester={selectedSemester}
          semesters={semesters}
          setSemesters={setSemesters}
          selectedSemesterId={selectedSemesterId}
        />
      </div>

      <div className="lg:sticky lg:top-24 h-fit">
        <GPASidebar
          courses={selectedSemester.courses}
          cumulativeGPA={cumulativeGPA}
        />
      </div>
    </div>
  );
}